import "./etb.css"
import { AccessTime } from "@mui/icons-material"

export default function Etb(etb) {
    const formatter = new Intl.DateTimeFormat("de-DE", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
  return (
    <>
    <div className="etb">
    <div className="etbtime">
            <AccessTime fontSize="small" className="etbtimeimg" />
            <div className="etbtimetime">heute, {formatter.format(Date.parse(etb.etb.createdAt))}</div>
        </div>
        <div className="etbheader">
            <div className="etbtype Alarm">{etb.etb.type}</div>
            <div className="etbtypedesc">{etb.etb.typedesc}</div>
            <div className="etbsource">{etb.etb.source}</div>
        </div>
        <div className="etbtitel">{etb.etb.titel}</div>
        <div className="etbtext">{etb.etb.text}</div>
    </div>
    </>
    )
}
